import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ReactCompareImage from 'react-compare-image';
import img1 from '../../Images/introWaldzustand.png';
import img2 from '../../Images/introBaumarten.png';
import logoDarkMode from '../../Images/waldmonitor_Mono Hell.png';
import { Grid, Box } from '@mui/material';

export default function ResponsiveDialog() {
    const [open, setOpen] = React.useState(true);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>

            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    
                <Grid item container alignItems="center" justifyContent="center" >

                    <Box
                        component="img"
                        sx={{
                            m: 1,
                            // width: "70vw",
                            // flexGrow:0.1,
                            // maxHeight: "100%"
                            maxWidth: "80%"
                            // maxHeight: { xs: 233, md: 167 },
                            // maxWidth: { xs: 350, md: 250 },
                        }}
                        src={logoDarkMode}
                    />
                </Grid>
                
                </DialogTitle>
                <DialogContent >
                    <DialogContentText mb={2}>
                        Der Waldmonitor Deutschland liefert erstmals eine satellitenbasierte Darstellung des Waldzustandes (links) und der Verteilung der Hauptbaumarten (rechts).
                    </DialogContentText>
                    <ReactCompareImage leftImage={img1} rightImage={img2} />
                    <Grid container justifyContent="center" mt={3}>
                    <Button onClick={handleClose} autoFocus>
                        Starten
                    </Button>
                    </Grid>
                    
                </DialogContent>
             
            </Dialog>
        </div>
    );
}
